import "$styles/index.css";

import { Application } from "@hotwired/stimulus";
import QuoteController from "./controllers/quote_controller.js";

window.Stimulus = Application.start();
Stimulus.register("quote", QuoteController);

// Le menu mobile est un <details> : un lien vers une ancre de la même page ne
// recharge rien, il faut donc le refermer à la main.
document.addEventListener("click", (event) => {
  const link = event.target.closest(".menu-panel a");
  if (link) link.closest("details")?.removeAttribute("open");
});
